import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'

Vue.use(VueRouter)

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error/404'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    meta: { title: '首页', icon: 'el-icon-s-home' },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index'),
        meta: { title: '首页', icon: 'el-icon-s-home' }
      }
    ]
  },
  {
    path: '/member',
    component: Layout,
    redirect: '/member/list',
    meta: { title: '会员管理', icon: 'el-icon-user-solid' },
    children: [
      { path: 'list', name: 'MemberList', component: () => import('@/views/member/list'), meta: { title: '会员列表' } },
      { path: 'detail/:id', name: 'MemberDetail', component: () => import('@/views/member/detail'), meta: { title: '会员详情' }, hidden: true }
    ]
  },
  {
    path: '/staff',
    component: Layout,
    redirect: '/staff/list',
    meta: { title: '玩家管理', icon: 'el-icon-s-custom' },
    children: [
      { path: 'list', name: 'StaffList', component: () => import('@/views/staff/list'), meta: { title: '玩家列表' } },
      { path: 'create', name: 'StaffCreate', component: () => import('@/views/staff/edit'), meta: { title: '新增玩家' }, hidden: true },
      { path: 'edit/:id', name: 'StaffEdit', component: () => import('@/views/staff/edit'), meta: { title: '编辑玩家' }, hidden: true }
    ]
  },
  {
    path: '/order',
    component: Layout,
    redirect: '/order/list',
    meta: { title: '订单管理', icon: 'el-icon-s-order' },
    children: [
      { path: 'list', name: 'OrderList', component: () => import('@/views/order/list'), meta: { title: '订单列表' } },
      { path: 'create', name: 'OrderCreate', component: () => import('@/views/order/create'), meta: { title: '创建订单' } }
    ]
  },
  {
    path: '/recharge',
    component: Layout,
    redirect: '/recharge/tier',
    meta: { title: '充值管理', icon: 'el-icon-money' },
    children: [
      { path: 'tier', name: 'RechargeTier', component: () => import('@/views/recharge/tier'), meta: { title: '充值档位' } },
      { path: 'list', name: 'RechargeList', component: () => import('@/views/recharge/list'), meta: { title: '充值流水' } }
    ]
  },
  // 权益福利：下一期上线，暂时隐藏菜单（hidden: true，页面与接口保留）
  {
    path: '/benefit',
    component: Layout,
    hidden: true,
    redirect: '/benefit/def',
    meta: { title: '权益福利', icon: 'el-icon-present' },
    children: [
      { path: 'def', name: 'BenefitDef', component: () => import('@/views/benefit/def'), meta: { title: '权益定义' } },
      { path: 'monthly', name: 'BenefitMonthly', component: () => import('@/views/benefit/monthly'), meta: { title: '月度福利' } },
      { path: 'record', name: 'BenefitRecord', component: () => import('@/views/benefit/record'), meta: { title: '发放记录' } }
    ]
  },
  {
    path: '/content',
    component: Layout,
    redirect: '/content/post-audit',
    meta: { title: '内容管理', icon: 'el-icon-document-copy' },
    children: [
      { path: 'post-audit', name: 'PostAudit', component: () => import('@/views/content/post-audit'), meta: { title: '动态审核' } },
      { path: 'comment', name: 'CommentManage', component: () => import('@/views/content/comment'), meta: { title: '评论管理' } },
      { path: 'report', name: 'ReportManage', component: () => import('@/views/content/report'), meta: { title: '举报处理' } },
      { path: 'sensitive', name: 'SensitiveWord', component: () => import('@/views/content/sensitive'), meta: { title: '敏感词' } },
      { path: 'faq', name: 'FaqKeyword', component: () => import('@/views/content/faq'), meta: { title: '关键词回复' } }
    ]
  },
  {
    path: '/activity',
    component: Layout,
    redirect: '/activity/list',
    meta: { title: '活动管理', icon: 'el-icon-s-flag' },
    children: [
      { path: 'list', name: 'ActivityList', component: () => import('@/views/activity/list'), meta: { title: '活动列表' } },
      { path: 'signup', name: 'ActivitySignup', component: () => import('@/views/activity/signup'), meta: { title: '报名名单' } }
    ]
  },
  {
    path: '/rank',
    component: Layout,
    redirect: '/rank/staff',
    meta: { title: '榜单管理', icon: 'el-icon-s-data' },
    children: [
      { path: 'staff', name: 'RankStaff', component: () => import('@/views/rank/staff'), meta: { title: '头牌榜' } },
      { path: 'consume', name: 'RankConsume', component: () => import('@/views/rank/consume'), meta: { title: '消费榜' } }
    ]
  },
  {
    path: '/naming',
    component: Layout,
    redirect: '/naming/list',
    meta: { title: '冠名管理', icon: 'el-icon-medal' },
    children: [
      { path: 'list', name: 'NamingList', component: () => import('@/views/naming/list'), meta: { title: '冠名排期' } },
      { path: 'apply', name: 'NamingApply', component: () => import('@/views/naming/apply'), meta: { title: '冠名申请' } }
    ]
  },
  {
    path: '/points',
    component: Layout,
    redirect: '/points/goods',
    meta: { title: '积分管理', icon: 'el-icon-goods' },
    children: [
      { path: 'goods', name: 'PointsGoods', component: () => import('@/views/points/goods'), meta: { title: '积分商品' } },
      { path: 'exchange', name: 'PointsExchange', component: () => import('@/views/points/exchange'), meta: { title: '兑换记录' } }
    ]
  },
  {
    path: '/message',
    component: Layout,
    redirect: '/message/internal',
    meta: { title: '消息管理', icon: 'el-icon-bell' },
    children: [
      { path: 'internal', name: 'MessageInternal', component: () => import('@/views/message/internal'), meta: { title: '站内消息' } },
      { path: 'push', name: 'MessagePush', component: () => import('@/views/message/push'), meta: { title: '模板推送' } },
      { path: 'lead', name: 'MessageLead', component: () => import('@/views/message/lead'), meta: { title: '咨询线索' } }
    ]
  },
  {
    path: '/setting',
    component: Layout,
    redirect: '/setting/admin',
    meta: { title: '系统设置', icon: 'el-icon-setting' },
    children: [
      { path: 'admin', name: 'SysAdmin', component: () => import('@/views/setting/admin'), meta: { title: '管理员' } },
      { path: 'dict', name: 'SysDict', component: () => import('@/views/setting/dict'), meta: { title: '字典' } },
      { path: 'config', name: 'SysConfig', component: () => import('@/views/setting/config'), meta: { title: '系统配置' } },
      { path: 'log', name: 'SysLog', component: () => import('@/views/setting/log'), meta: { title: '操作日志' } }
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]

const router = new VueRouter({
  mode: 'hash',
  base: '/',
  routes: constantRoutes
})

export default router
